import React from 'react'
import numbro from 'numbro';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";

// Core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";

import dashGeneralPageStyle from "assets/jss/prehnit/views/dashGeneralPageStyle.jsx";

import { withNamespaces } from "react-i18next";
import { Context } from "Context.jsx";

import CLCColors from "assets/data/clc_colors.js";


class CLCTableCard extends React.Component {

  // filterData(data, col, id) {
  //   return data.filter( row => {
  //     return row[col] == id; //must be loose equal ('==')
  //   });
  // }

  tblData(unit) {
    const { t, classes } = this.props;

    let data1 = this.props.allData.filter(x => x[this.props.filterColumnName] == this.props.filterId_1);
    let data2 = this.props.allData.filter(x => x[this.props.filterColumnName] == this.props.filterId_2);

    let elements = [];
    let elementsHash = {};

    for (let i = 0; i < data1.length; i++) {
      let code = data1[i].kod_3;
      if (!elementsHash[code]) {
        elements.push(data1[i]);
        elementsHash[code] = true;
      }
    }

    if (!this.props.single) {
      for (let i = 0; i < data2.length; i++) {
        let code = data2[i].kod_3;
        if (!elementsHash[code]) {
          elements.push(data2[i]);
          elementsHash[code] = true;
        }
      }
    }

    // let sorted_elements_1 = this.filterData(elements, 'id', this.props.filterId_1).sort(this.props.sortFunc);
    // let sorted_elements_2 = this.filterData(elements, 'id', this.props.filterId_2).sort(this.props.sortFunc);

    // let sorted_elements = [];
    // sorted_elements_1.forEach(x => sorted_elements.push(x));
    // sorted_elements_2.forEach(function(el) {
    //   let exists = this.filterData(sorted_elements_1, 'id', el.id);
    //   if (exists && exists.length === 0) {
    //     sorted_elements.push(el);
    //   }
    // }.bind(this))

    let sorted_elements = elements.sort(this.props.sortFunc);

    let tableData = [];

    for (let i = 0; i < sorted_elements.length; i++) {
      let row = [];
      let code = sorted_elements[i].kod_3;
      row.push(<div><div className={classes.clcBox} style={{ backgroundColor: CLCColors[code] }}>&nbsp;</div>{code}</div>);
      row.push(t("clc:" + code));

      // let val1 = this.filterData(data1, 'kod_3', code)
      let val1 = data1.filter(x => x['kod_3'] == code);
      if (val1.length > 0) {
        row.push(numbro(unit.transform(val1[0]['pov_3_ha'] * 100)).divide(100).format());
      } else {
        row.push("--");
      }

      if (!this.props.single) {
        row.push(<div><div className={classes.clcBox} style={{ backgroundColor: CLCColors[code] }}>&nbsp;</div>{code}</div>);
        row.push(t("clc:" + code));

        // let val2 = this.filterData(data2, 'kod_3', code)
        let val2 = data2.filter(x => x['kod_3'] == code);
        if (val2.length > 0) {
          row.push(numbro(unit.transform(val2[0]['pov_3_ha'] * 100)).divide(100).format());
        } else {
          row.push("--");
        }
      }

      tableData.push(row);
    }

    return tableData;
  }

  footerData(unit) {
    const { t } = this.props;

    // let data = this.filterData(this.props.allData, this.props.filterColumnName, this.props.filterId);
    let data = this.props.allData.filter(x => x[this.props.filterColumnName] == this.props.filterId);

    let codes = [];
    let areas = [];
    let codesHash = {};

    for (let i = 0; i < data.length; i++) {
      let code = data[i].kod_1;
      let area = data[i].pov_ha_1;
      if (!codesHash[code]) {
        codes.push(code);
        areas.push(area);
        codesHash[code] = true;
      }
    }


    let res = "";

    for (let i = 0; i < codes.length; i++) {
      let c = codes[i]
      res += c + "xx - " + t("clc:" + c) + ": " + numbro(unit.transform(areas[i])).format() + " " + unit.short + ";   ";
    }
    return (<div>{res}</div>);
  }

  tblHeaders(unit) {
    const { t } = this.props;

    if (this.props.single) {
      return [t("map:class-code")
        , t("map:class-name")
        , <div>{t("map:area")}<small>{" (" + unit.short + ")"}</small></div>
      ]
    } else {
      return [t("map:class-code")
        , t("map:class-name")
        , <div>{t("map:area")}<small>{" (" + unit.short + ")"}</small></div>
        , t("map:class-code")
        , t("map:class-name")
        , <div>{t("map:area")}<small>{" (" + unit.short + ")"}</small></div>
      ]
    }
  }

  getStats(stats, region) {
    const { t } = this.props;

    let data = stats.filter(x => x.region_code == region);
    if (data && data.length > 0) {
      let d = data[0];
      let title = d.region_title;
      let token = d.region_title_trans_token;
      if (token && token.length > 0) {
        title = t(token);
      }
      let area = d.region_area_ha
      let count = d.code_3_count;

      return (<div>
        <h4>{title}</h4>
        <p>
          <Context.Consumer>
            {ctx => t("map:area") + ": " + numbro(ctx.unit.transform(area) * 100).divide(100).format() + " " + ctx.unit.short}
          </Context.Consumer>
        </p>
        <p></p>
        <p>{t("map:number-of-classes")}: {count}</p>
      </div>);
    }
    return null;
  }



  render() {
    const { classes } = this.props;
    return (
      <Context.Consumer>
        {ctx =>
          <Card>
            <CardHeader color={this.props.color}>
              <CardIcon color={this.props.color}>
                <Icon>grid_on</Icon>
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {this.props.title}
                <small> - {this.props.subtitle}</small>
              </h4>
            </CardHeader>
            <CardBody>
              {this.props.single ? null
                : <GridContainer>
                  <GridItem xs={6} style={{ paddingLeft: "23px" }}>
                    {this.props.filterId_1 ? this.getStats(this.props.statsData, this.props.filterId_1) : null}
                  </GridItem>
                  <GridItem xs={6}>
                    {this.props.filterId_2 ? this.getStats(this.props.statsData, this.props.filterId_2) : null}
                  </GridItem>
                </GridContainer>
              }

              <Table
                tableHead={this.tblHeaders(ctx.unit)}
                tableData={this.tblData(ctx.unit)}

                customHeadClassesForCells={[0, 2, 3, 5]}
                customHeadCellClasses={[
                  classes.textLeft, classes.textRight, classes.textCenter, classes.textRight
                ]}

                customClassesForCells={[0, 2, 3, 5]}
                customCellClasses={[
                  classes.textLeft, classes.textRight, classes.textCenter, classes.textRight
                ]}
              />
            </CardBody>
            <CardFooter className={classes.cardFooter}>
            </CardFooter>
          </Card>
        }
      </Context.Consumer>
    );
  }
}

export default withNamespaces()(withStyles(dashGeneralPageStyle)(CLCTableCard));
